import type React from 'react';

import { TagList } from '@xing-com/crate-jobs-domain-serps-components-tag-list';
import { capitalizeFirstLetter } from '@xing-com/crate-jobs-domain-serps-helpers';
import {
  useSeoLinkBoxes,
  useSerpsMatch,
} from '@xing-com/crate-jobs-domain-serps-hooks';

// The FE will control what kind of link boxes can be displayed
const WHITE_LIST: string[] = [
  'nearby_job_role',
  'local_skill',
  'local_job_role_related_job_roles',
  'local_skill_related_job_roles',
  'popular_location',
  'job_role_employment_type',
  'location_employment_type',
  'location_most_sought_after_job_titles',
  'related_job_roles',
  'skill_related_job_roles',
  'skill_top_locations',
];

const SHOW_COUNT_WHITE_LIST: string[] = [
  'popular_location',
  'job_role_employment_type',
  'location_employment_type',
  'location_most_sought_after_job_titles',
  'skill_top_locations',
];

export const LinkBoxes: React.FC = () => {
  const serps = useSerpsMatch();
  const { data } = useSeoLinkBoxes();

  return (
    <>
      {data?.map((item) => {
        return WHITE_LIST.includes(item.kind) ? (
          <TagList
            key={item.kind}
            headerCopyKey={`XJM_SEO_LINK_BOXES_${item.kind.toLocaleUpperCase()}`}
            headerCopyValues={{
              categoryValue: capitalizeFirstLetter(serps?.categoryValue || ''),
              subcategoryValue: capitalizeFirstLetter(
                serps?.subcategoryValue || ''
              ),
            }}
            serpsList={item.entries}
            showCount={
              SHOW_COUNT_WHITE_LIST.includes(item.kind) ? 'show' : 'hide'
            }
          />
        ) : null;
      })}
    </>
  );
};
